import type { Icon } from "@/components/Base/Lucide/Lucide.vue";
import { defineStore } from "pinia";
import { useAuthStore } from './auth';

export interface Menu {
  icon: Icon;
  title: string;
  badge?: number;
  pageName?: string;
  subMenu?: Menu[];
  ignore?: boolean;
  requiresRole?: string | string[];
}

export interface MenuState {
  value: Array<Menu | string>;
}

export const useMenuStore = defineStore("menu", {
  state: (): MenuState => ({
    value: [
      "DASHBOARDS",
      {
        icon: "ActivitySquare",
        pageName: "dashboard",
        title: "Dashboard",
      },
      "DATA MANAGEMENT",
        {
          icon: "Compass",
          pageName: "service-list",
          title: "Services",
        },
              {
        icon: "BookUser",
        pageName: "contacts",
        title: "Contacts",
      },
      {
        icon: "Building2",
        pageName: "vendor-list",
        title: "Vendors",
      },
      "SYSTEM MANAGEMENT",
      {
        icon: "Play",
        pageName: "status-list",
        title: "Statuses",
        requiresRole: 'Admin',
      },
      {
        icon: "LayoutPanelTop",
        pageName: "piidatatype-list",
        title: "PII Data Types",
      },
      {
        icon: "Gavel",
        pageName: "legalbasis-list",
        title: "Legal Bases",
      },
      {
        icon: "BrainCog",
        pageName: "AdminProcessingPurposes",
        title: "Processing Purposes",
        requiresRole: 'Admin',
      },
      {
        icon: "Folders",
        pageName: "AdminDataSubjectCategories",
        title: "Data Subject Categories",
        requiresRole: 'Admin',
      },
      {
        icon: "Archive",
        pageName: "AdminRetentionPolicies",
        title: "Retention Policies",
        requiresRole: 'Admin',
      },
      {
        icon: "ServerCog",
        pageName: "AdminFlowTypes",
        title: "Flow Types",
        requiresRole: 'Admin',
      },
      {
        icon: "ShieldCheck",
        pageName: "risklevel-list",
        title: "Risk Levels",
      },
      {
        icon: "Activity",
        pageName: "system-status",
        title: "System Status",
      },
      {
        icon: "History",
        pageName: "audit-log",
        title: "Audit Log",
        requiresRole: ['Admin', 'Auditor'],
      },
      "USER MANAGEMENT",
      {
        icon: "SquareUser",
        pageName: "users",
        title: "Users",
      },
      {
        icon: "CakeSlice",
        pageName: "departments",
        title: "Departments",
      },
      {
        icon: "PackagePlus",
        pageName: "add-user",
        title: "Add User",
      },
      "ACCOUNT",
      {
        icon: "PercentSquare",
        pageName: "billing",
        title: "Billing",
      },
      {
        icon: "Ticket" ,
        pageName: "pricing",
        title: "Pricing",
      },
      {
        icon: "DatabaseZap",
        pageName: "invoice",
        title: "Invoice",
      },
    ],
  }),
  getters: {
    filtered: (state) => {
      const auth = useAuthStore();
      const filterMenu = (items: Array<Menu | string>): Array<Menu | string> => {
        const res: Array<Menu | string> = [];
        for (const item of items) {
          if (typeof item === 'string') {
            res.push(item);
            continue;
          }
          if (item.requiresRole) {
            const roles = Array.isArray(item.requiresRole)
              ? item.requiresRole
              : [item.requiresRole];
            if (!roles.includes(auth.user?.role as string)) {
              continue;
            }
          }
          const copy: Menu = { ...item };
          if (item.subMenu) copy.subMenu = filterMenu(item.subMenu) as Menu[];
          res.push(copy);
        }
        return res;
      };
      return filterMenu(state.value);
    },
  },
});
